export default defineNuxtRouteMiddleware(async () => {
  const dashStore = useDashboardStore();
  const token = useCookie<string | null>('userToken');

  // Run on server render to hydrate the user before the page is sent.
  if (process.server && token.value && !dashStore.getIsUserConnected) {
    try {
      await dashStore.fetchUserByToken();
    } catch (error) {
      // If the token is invalid, swallow the error so rendering can continue.
      console.error('Failed to hydrate user from cookie (SSR)', error);
    }
  }
});
